import { Button, useMediaQuery } from "@rshbintech.dboul/core-ui";
import { useCallback, useMemo } from "react";
import { AppLocale } from "../../types";
import { useAppTranslation } from "../../../hooks";
import { localeTextMap } from "./constants";
import styles from "./styles.scss";

export const ChangeLanguageButton = () => {
  const { changeLanguage, language } = useAppTranslation();
  const matchesMobile = useMediaQuery("mobile");

  const currentLanguage = useMemo(
    () =>
      language.startsWith("en") ? localeTextMap.ru_RU : localeTextMap.en_US,
    [language]
  );

  const handleChangeLanguage = useCallback(() => {
    const nextLang: AppLocale = language.startsWith("ru") ? "en_US" : "ru_RU";

    changeLanguage?.(nextLang);
  }, [changeLanguage, language]);

  return (
    <Button
      htmlType="button"
      dataTestId="change-language-button"
      type="link"
      size={matchesMobile ? "small" : "large"}
      className={styles["button-link"]}
      onClick={handleChangeLanguage}
    >
      {currentLanguage}
    </Button>
  );
};
